jQuery(document).ready(function() {

    jQuery('.footer-top-mid-left > h4').on('click', function(e){
        jQuery('.footer-top-mid-left-link').toggleClass('active');
        
     
     
    
    });

    jQuery('.footer-top-mid-right > h4').on('click', function(e){
        jQuery('.footer-top-mid-right-link').toggleClass('active');
    
     
    });

    jQuery('.filter-item-all').on('click', function(e){
        jQuery('.filter-item-banque, .filter-item-mecenat, .filter-item-recrutement, .filter-item-responsable').toggleClass('open');
    
     
    });
    jQuery('.filter-search-item-all').on('click', function(e){
        jQuery('.filter-search-item-banque, .filter-search-item-mecenat, .filter-search-item-recrut, .filter-search-item-responsable, .filter-search-item-newsroom').toggleClass('open');
    
     
    });




}); 
